// Form validation for Employee form
import { plaintextValidator } from '../fields';

const config = { mandatory: true, customError: `can't be blank` };

export default {
  content: plaintextValidator(config),
  subject: plaintextValidator(config),
  name: plaintextValidator(config)
};
